import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TmsWebBaseEditCreateService } from 'tms-web-shared';
import { UserCustomer } from '../models';

@Injectable({
  providedIn: 'root',
})
export class UserCustomerService extends TmsWebBaseEditCreateService<UserCustomer, UserCustomer> {
  constructor() {
    super('UserCustomer', $localize`User Customer`);
  }

  getForUser(id: string): Observable<UserCustomer[]> {
    return this.httpService.get<UserCustomer[]>(`${this.apiUrl}/CustomersForUser?id=${id}`);
  }
}
